import React from "react";
import { CriticalPeriodKind, CriticalPeriodDef } from "../../../../models/chart_model";
import { KIND_DEFAULTS } from "../hooks/useCriticalPeriods";

interface Props {
  periods: CriticalPeriodDef[];
  activePeriodKinds: Set<CriticalPeriodKind>;
  onToggleAll: () => void;
}

export function CriticalPeriodsPanel({ periods, activePeriodKinds, onToggleAll }: Props) {
  if (!periods || periods.length === 0) return null;
  const isActive = activePeriodKinds.size > 0;
  const activeCount = activePeriodKinds.size;

  return (
    <button
      type="button"
      className={`cp-toggle-btn ${isActive ? "cp-toggle-btn--active" : "cp-toggle-btn--inactive"}`}
      onClick={onToggleAll}
      aria-pressed={isActive}
      title={isActive ? `Showing ${activeCount} critical time band${activeCount !== 1 ? "s" : ""} — click to hide` : "Highlight critical time periods (Solar, Ramp, Peak, Valley)"}
    >
      <span className="cp-icon3d-stack" aria-hidden>
        <span className="cp-icon3d cp-icon3d--solar">{KIND_DEFAULTS.solar.icon}</span>
        <span className="cp-icon3d cp-icon3d--ramp">{KIND_DEFAULTS.evening_ramp.icon}</span>
        <span className="cp-icon3d cp-icon3d--valley">{KIND_DEFAULTS.valley.icon}</span>
      </span>
      <span className="cp-toggle-label-wrap">
        <span className="cp-toggle-label">Critical Periods</span>
        <span className="cp-toggle-sublabel">
          {isActive ? `${activeCount} band${activeCount !== 1 ? "s" : ""} visible` : "Solar · Evening · Night"}
        </span>
      </span>
      <span className={`cp-toggle-pill ${isActive ? "is-on" : "is-off"}`}>
        <span className="cp-toggle-knob" />
        <span className="cp-toggle-pill-text">{isActive ? "ON" : "OFF"}</span>
      </span>
    </button>
  );
}
